import PublicPropertiesCollection from '@netx/core-app/collections/publicProperties';

export const publicProperties = new PublicPropertiesCollection();

export default publicProperties;
